/* eslint-disable import/prefer-default-export */

import { formatNumber } from "aegion_common_utilities/lib/format/numeric";

/* eslint-disable no-param-reassign */
const isDefined = v => v !== undefined && v !== null;

const Y2_MAX_MULTIPLIER = 4;
const Y2_MAX_SCALE = 2;

export const createGetXYMinMax = (props, yProps, y2Props) => {
	return (item, currentXMin, currentXMax, currentYMin, currentYMax, currentY2Min, currentY2Max) => {
		let xMin = currentXMin;
		let xMax = currentXMax;
		let yMin = currentYMin;
		let yMax = currentYMax;
		let y2Min = currentY2Min;
		let y2Max = currentY2Max;

		yProps.forEach(p => {
			const val = item[p];

			if (!isDefined(yMin)) {
				yMin = val;
			}

			if (!isDefined(yMax)) {
				yMax = val;
			}

			if (isDefined(val)) {
				if (val < yMin) {
					yMin = val;
				}
				if (val > yMax) {
					yMax = val;
				}
			}
		});

		y2Props.forEach(p => {
			const val = item[p];

			if (!isDefined(y2Min)) {
				y2Min = val;
			}

			if (!isDefined(y2Max)) {
				y2Max = formatNumber(val * Y2_MAX_MULTIPLIER, { scale: Y2_MAX_SCALE });
			}

			if (isDefined(val)) {
				if (val < y2Min) {
					y2Min = val;
				}
				if (val * Y2_MAX_MULTIPLIER > y2Max) {
					y2Max = formatNumber(val * Y2_MAX_MULTIPLIER, { scale: Y2_MAX_SCALE });
				}
			}
		});

		const x = item.gpsdistance;
		if (!isDefined(xMin)) {
			xMin = x;
		}
		if (!isDefined(xMax)) {
			xMax = x;
		}
		if (isDefined(x) && isDefined(xMin) && xMin > x) {
			xMin = x;
		}
		if (isDefined(x) && isDefined(xMax) && xMax < x) {
			xMax = x;
		}

		return { xMin, xMax, yMin, yMax, y2Min, y2Max };
	};
};

export const createComputeYMinYMax = readingKeys => {
	const props = readingKeys.map(rk => rk.value);
    const yProps = readingKeys.filter(rk => rk.yAxisID === 'y').map(rk => rk.value)
    const y2Props = readingKeys.filter(rk => rk.yAxisID === 'y2').map(rk => rk.value)
	const getXYMinMax = createGetXYMinMax(props, yProps, y2Props);
	return (survey, reading) => {
		const {
			xMin: currentXMin,
			xMax: currentXMax,
			yMin: currentYMin,
			yMax: currentYMax,
			y2Min: currentY2Min,
			y2Max: currentY2Max
		} = survey;
		const { xMin, xMax, yMin, yMax, y2Min, y2Max } = getXYMinMax(
			reading,
			currentXMin,
			currentXMax,
			currentYMin,
			currentYMax,
			currentY2Min,
			currentY2Max,
		);
		survey.xMin = xMin;
		survey.xMax = xMax;
		survey.yMin = yMin;
		survey.yMax = yMax;
		survey.y2Min = y2Min;
		survey.y2Max = y2Max;
	};
};
